import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
export const SettingsLoadError = ({
  label,
  retry,
}: {
  label: string;
  retry?: () => void;
}) => (
  <Stack gap={3} align="start" className="p-4">
    <Text role="alert" tone="destructive">
      {label} Try again.
    </Text>
    <Button variant="outline" size="sm" onClick={retry}>
      Retry
    </Button>
  </Stack>
);
